// The param-type registry, and the discriminated union that hangs off it.
//
// `config` is resolved by POSITION: `resolver: "type"` means "look at the
// sibling `type` property, find its value's index in that property's `enum`,
// and take `oneOf[thatIndex]`" — see resolveOneOfEx in @repoflow/schema. So the
// two arrays below must stay in lockstep. Appending to one without appending to
// the other silently re-points every later type at the wrong config shape.
//
// Eleven of the archived project's thirteen types survive the port. `paragraph`
// came back with the element type of the same name — one Quill editor answers
// for both, and `common/render/types` converts the stored delta to HTML on the
// way to a template. `image` came back with the Files section and the anonymous
// file route that made a picked file readable from a published page; its shape
// is `/Types/Image` in ./types/image, and it is an object rather than a URL
// because an <img> on a page needs alt text.
//
// The two still missing are `markdown` (needs markdown-it) and
// `object-selector` (only ever used by an entity that was not ported). Adding
// one back is this file plus a widget — nothing else knows the list.
//
// APPEND, NEVER INSERT. The `config` union below is resolved BY POSITION
// against this array, so putting `image` anywhere but the end would silently
// re-point every type after it at the wrong config shape. It is at the end for
// that reason and not because it was an afterthought.
export const properties = {};

export const types = [
  "text",
  "checkbox",
  "options",
  "number",
  "color",
  "date",
  "icon",
  "object",
  "list",
  "paragraph",
  "image",
];

export const paramProperties = {
  type: {
    label: "Type",
    type: "string",
    enum: types,
    minLength: 1,
    default: "",
  },
  config: {
    label: "Details",
    type: "object",
    oneOf: [
      { $ref: "/Types/Param/Type/Text" },
      { $ref: "/Types/Param/Type/Checkbox" },
      { $ref: "/Types/Param/Type/Options" },
      { $ref: "/Types/Param/Type/Number" },
      { $ref: "/Types/Param/Type/Color" },
      { $ref: "/Types/Param/Type/Date" },
      { $ref: "/Types/Param/Type/Icon" },
      { $ref: "/Types/Param/Type/Object" },
      { $ref: "/Types/Param/Type/List" },
      { $ref: "/Types/Param/Type/Paragraph" },
      { $ref: "/Types/Param/Type/Image" },
    ],
    resolver: "type",
    default: {},
  },
};
